import Vue from "vue/dist/vue.js";
import Vuex from "vuex";
import axios from "axios";

var csrf = $("meta[name=csrf-token]").attr("content");
axios.defaults.headers.common["X-CSRF-Token"] = csrf;

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    itemShowMode: "table",
    currentCart: {},
    couponTypes: [],
    couponType: null,
    customers: [],
    currentCustomer: null,
    items: [],
    priceRange: [0, 0],
    sortBy: "default",
    search: "",
    currentCoupons: [],
    itemsLoading: true,
    restoreOrder: {},
    // cartCustomAmount: {}
  },
  mutations: {
    set_coupon_types: (state, payload) => {
      state.couponTypes = payload;
    },
    set_coupon_type: (state, payload) => {
      state.couponType = payload;
    },
    set_customers: (state, payload) => {
      state.customers = payload;
    },
    set_current_customer: (state, payload) => {
      state.currentCustomer = payload;
    },
    set_items: (state, payload) => {
      state.items = payload;
    },
    set_price_range: (state, payload) => {
      state.priceRange = payload;
    },
    set_sort_by: (state, payload) => {
      state.sortBy = payload;
    },
    set_search: (state, payload) => {
      state.search = payload;
    },
    set_current_cart: (state, payload) => {
      state.currentCart = payload;
    },
    set_current_coupons: (state, payload) => {
      state.currentCoupons = payload;
    },
    set_item_show_mode: (state, payload) => {
      state.itemShowMode = payload;
    },
    set_items_loading: (state, payload) => {
      // console.log('set_items_loading', payload);
      state.itemsLoading = payload;
    },
    set_restore_order: (state, payload) => {
      state.restoreOrder = payload;
    },
  },
  actions: {
    getCouponTypes: async (context) => {
      try {
        const { data } = await axios.get("/api/coupon_types");
        context.commit("set_coupon_types", data);
      } catch (error) {
        console.error("取得優惠券類型失敗:", error);
      }
    },
    getCurrentCouponType: async (context) => {
      try {
        const { data } = await axios.get("/api/get_current_coupon_type");
        context.commit("set_coupon_type", data.current_coupon_type);
      } catch (error) {
        console.error("取得當前優惠券類型失敗:", error);
      }
    },
    getCurrentCustomer: async (context) => {
      try {
        const { data } = await axios.get("/api/get_current_customer");
        context.commit("set_current_customer", data.current_customer);
      } catch (error) {
        console.error("取得當前客戶失敗:", error);
      }
    },
    getCustomers: async (context) => {
      try {
        const { data } = await axios.get("/api/get_customers");
        context.commit("set_customers", data.customers);
      } catch (error) {
        console.error("取得客戶列表失敗:", error);
      }
    },
    setCurrentCustomer: async (context, payload) => {
      try {
        const { data } = await axios.post("/api/set_current_customer", {
          id: payload,
        });
        if (data.success) {
          context.commit("set_current_customer", data.customer);
          // 添加小延遲確保後端 session 更新完成
          await new Promise((resolve) => setTimeout(resolve, 200));
        }
      } catch (error) {
        console.error("設定當前客戶失敗:", error);
      }
    },
    getItems: async (context, payload) => {
      // 先設定 loading 狀態為 true
      context.commit("set_items_loading", true); // 註解：設定 loading 狀態為 true

      const firstSubCategoryId = document
        .getElementById("app-meta")
        .getAttribute("data-first-sub-category-id");

      try {
        let response;
        if (payload && payload.length > 0) {
          response = await axios.get("/api/items", {
            params: {
              item_ids: payload,
              cust_acct_site_id:
                context.state.currentCustomer?.cust_acct_site_id,
            },
          });
        } else {
          response = await axios.get("/api/items", {
            params: {
              sub_category_id: firstSubCategoryId,
              cust_acct_site_id:
                context.state.currentCustomer?.cust_acct_site_id,
            },
          });
        }
        if (response.data.success) {
          context.commit("set_items", response.data.items);
        }
      } catch (error) {
        console.error("取得商品列表失敗:", error);
      } finally {
        // 請務必在 finally 設定 loading 為 false
        context.commit("set_items_loading", false); // 註解：資料取得結束，關閉 loading
      }
    },
    getCurrentCart: async (context) => {
      try {
        const { data } = await axios.get("/api/get_current_cart");
        context.commit("set_current_cart", data.current_cart);
      } catch (error) {
        console.error("取得當前購物車失敗:", error);
      }
    },
    getCurrentCoupons: async (context) => {
      try {
        const { data } = await axios.get("/api/get_current_coupons");
        // console.log('getCurrentCoupons', data)
        context.commit("set_current_coupons", data.coupons);
      } catch (error) {
        console.error("取得當前優惠券失敗:", error);
      }
    },
    clearCurrentCart: async (context) => {
      // 需要慢一點所以用setTimeout 500的方式
      return new Promise((resolve) => {
        setTimeout(async () => {
          try {
            const { data } = await axios.delete("/api/clear_cart");
            context.commit("set_current_cart", {});
            resolve(data);
          } catch (error) {
            console.error("清空購物車失敗:", error);
            resolve(null);
          }
        }, 500);
      });
    },
    setCart: async (context, payload) => {
      try {
        const { data } = await axios.post("/api/set_cart", payload);
        context.commit("set_current_cart", data.current_cart);
      } catch (error) {
        console.error("設定購物車失敗:", error);
      }
    },
    getRestoreOrder: async (context) => {
      try {
        const { data } = await axios.get("/api/get_restore_order");
        context.commit("set_restore_order", data.restore_order);
      } catch (error) {
        console.error("取得恢復訂單失敗:", error);
      }
    },
  },
  getters: {},
});

export default store;
